import {h} from 'preact';
import {createPortal} from 'preact/compat';
import {useState} from "preact/hooks";
import { CloseOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';

const steps = {
  shortcuts: 'shortcuts',
  speedsBuilding: 'speedsBuilding',
  fastSwitching: 'fastSwitching',
  importingData: 'importingData',
}

export default function MMGTourModal({open, onClose}) {
  const [step, setStep] = useState(steps.shortcuts);

  function onModalClose() {
    setStep(steps.shortcuts);
    onClose();
  }

  return !open ? null : createPortal(<div>
    <div className="modal-back" onClick={onModalClose} />
    <div className="modal tour-modal">
      <div class="close-btn" onClick={onModalClose}><CloseOutlined/></div>
      {step === steps.shortcuts &&
      <div class="content">
        <video playsInline muted autoPlay loop src="https://timber.mhmcdn.com/site/timber/MMGTour1.mp4"/>
        <div class="step-text">
          <div class="step-title">How to use My Menu Groups</div>
          <div class="step-desc">Shortcuts for typed or imported menu data</div>
          <div class="navigation">
            <div class="step-num">1 / 4</div>
            <div onClick={() => setStep(steps.speedsBuilding)} class="step-next"><RightOutlined/></div>
          </div>
        </div>
      </div>}

      {step === steps.speedsBuilding &&
      <div class="content">
        <video playsInline muted autoPlay loop src="https://timber.mhmcdn.com/site/timber/MMGTour2.mp4"/>
        <div class="step-text">
          <div class="step-title">How to use My Menu Groups</div>
          <div class="step-desc">Build menu sections fast with point and click</div>
          <div class="navigation">
            <div onClick={() => setStep(steps.shortcuts)} class="step-back"><LeftOutlined/></div>
            <div class="step-num">2 / 4</div>
            <div onClick={() => setStep(steps.fastSwitching)} class="step-next"><RightOutlined/></div>
          </div>
        </div>
      </div>}

      {step === steps.fastSwitching &&
      <div class="content">
        <video playsInline muted autoPlay loop src="https://timber.mhmcdn.com/site/timber/MMGTour3.mp4"/>
        <div class="step-text">
          <div class="step-title">How to use My Menu Groups</div>
          <div class="step-desc">Great for adding POS data</div>
          <div class="navigation">
            <div onClick={() => setStep(steps.speedsBuilding)} class="step-back"><LeftOutlined/></div>
            <div class="step-num">3 / 4</div>
            <div onClick={() => setStep(steps.importingData)} class="step-next"><RightOutlined/></div>
          </div>
        </div>
      </div>}

      {step === steps.importingData &&
      <div class="content">
        <video playsInline muted autoPlay loop src="https://timber.mhmcdn.com/site/timber/MMGTour4.mp4"/>
        <div class="step-text">
          <div class="step-title">How to use My Menu Groups</div>
          <div class="step-desc">Also great for switching templates</div>
          <div class="navigation">
            <div onClick={() => setStep(steps.fastSwitching)} class="step-back"><LeftOutlined/></div>
            <div class="step-num">4 / 4</div>
          </div>
        </div>
      </div>}
    </div>
  </div>, document.getElementById('modals'));
}
